import React from "react";
import { Box, styled } from "@mui/material";

import { MTable, SearchBar } from "../v3";

/**
 * A component that displays a paginated and searchable table of tools usage history.
 *
 * @param {string} searchText - The current search text.
 * @param {function} onSearchChange - Callback function to call when the search input changes.
 * @param {boolean} loading - True if the component is in a loading state.
 * @param {Array} columnHeaders - The headers of the table.
 * @param {Array} tableRows - The rows of the table.
 */
export const AssignedTools = ({ searchText, onSearchChange = () => {}, loading, columnHeaders, tableRows }) => {
  return (
    <>
      <TableContainer>
        <SearchContainer>
          <SearchBar placeholder="search" searchText={searchText} onSearchChange={onSearchChange} />
        </SearchContainer>
        <MTable loading={loading} columnHeaders={columnHeaders} tableRows={tableRows} showExportButton />
      </TableContainer>
    </>
  );
};

const TableContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  marginTop: 10,
  display: "flex",
  flexDirection: "column",
}));

const SearchContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  left: 4,
  zIndex: 2,
}));
